/*
akhila 12/15/2022  2701012930 Added Formula Table
Akhila 01/26/2023  2701012930 Added handleDirty while deleting the record
Raghu 02/28/2023 2701012930 added new class for table
Ravi 05/31/2023 2701012930 changed delete popup message
*/
import React, {useState} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';

export default function FilterTable({
  fieldListCode,
  filterFields,
  setFilterFields,
  deletedIds,
  setDeletedIds,
  handleDirty,
}) {
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const columns = [
    {
      title: 'Category',
      // field: "category",
      render: (rowData) => {
        return rowData?.category === 'CL' ?
        `CL - Client` :
          rowData?.category === 'CO' ?
        `CO - Core` :
            '';
      },
      width: '1%',
    },
    {
      title: 'Repository Name',
      field: 'repositoryName',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },

    {
      title: 'Field Type',
      field: 'fieldType',
    },
    // {
    //   title: "Repository Type",
    //   field: "repositoryType",
    // },
  ];

  const [rows, setRows] = useState(defaultRows);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const arr = [...filterFields];
        const newData = arr.filter(
          (row) =>
            row.fieldName.concat(row.repositoryName) !==
            deleteData?.fieldName.concat(deleteData?.repositoryName),
        );
        const newDeletedIds = [...deletedIds];
        if (deleteData?.formulaFieldMapId) {
          newDeletedIds.push(deleteData?.formulaFieldMapId);
        }
        setFilterFields(newData);
        setDeletedIds(newDeletedIds);
        handleDeleteClose();
        resolve();
      }, 1000);
      handleDirty(true);
    });
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Field"
        value={`Are you sure you want to delete the ${deleteData?.fieldName} Field?`}
        // value={`Are you sure you want to delete the ${deleteData?.fieldName} field from the ${
        //   fieldListCode ? fieldListCode : ""
        // } Select Fields?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="new-standard-textfields">
        {}
        <div className="custom-table global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={filterFields}
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon />,
                  tooltip: 'Delete',
                  disabled: filterFields.length === 1,
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
